module.exports = __webpack_public_path__ + "static/media/creator_id.f48c933e.png";